import websiteAdmin from './websiteAdmin'
import distribution from './distribution'
import deadLinks from './deadLinks'
import keyword from './keyword'
import cacheManage from './cacheManage'

export default {
    ...websiteAdmin,
    ...distribution,
    ...deadLinks,
    ...keyword,
    ...cacheManage
}
